import React from 'react';

interface HamburgerIconProps {
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}

const HamburgerIcon: React.FC<HamburgerIconProps> = ({
  width = 24,
  height = 24,
  stroke = "#666666",
  strokeWidth = 2
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M4 6H20M4 12H20M4 18H20" 
        stroke={stroke} 
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

export default HamburgerIcon;